import validateField from './validateField';
export default function validateFields(elements = [], options = Object.freeze({})) {
  const {
    skipRequiredCheck = false
  } = options;
  return elements.reduce((result, element) => {
    if (element.elementType === 'fieldGroupInstance') {
      const errors = validateFields(element.elements, {
        skipRequiredCheck
      });
      return {
        ...errors,
        ...result
      };
    }
    const errors = validateField(element, skipRequiredCheck);
    return {
      ...result,
      [element.id]: errors
    };
  }, Object.freeze({}));
}